var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddArtistProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.40215 27.0997C6.34495 28.0425 7.28776 28.0425 8.70197 27.5711L22.6345 20.3937C23.4376 19.98 23.6054 18.9044 22.9668 18.2656L14.2362 9.53509C13.5974 8.89635 12.5218 9.06425 12.1081 9.86729L4.93073 23.7999C4.45933 25.214 4.45933 26.1568 5.40215 27.0997Z",
    stroke: "#8800FF",
    strokeWidth: 2.66667,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.002 8.50001L25.8253 7.58831C26.2402 7.38089 26.33 6.82798 26.002 6.50001C25.674 6.17203 25.7637 5.61913 26.1786 5.4117L28.002 4.50001",
    stroke: "#8800FF",
    strokeWidth: 2.66667,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.334 11.1667H21.5007",
    stroke: "#8800FF",
    strokeWidth: 2.66667,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.834 15.8333H26.0007",
    stroke: "#8800FF",
    strokeWidth: 2.66667,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0013 5.83334L14.668 3.83334",
    stroke: "#8800FF",
    strokeWidth: 2.66667,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.668 6.50001L21.3346 3.16667",
    stroke: "#8800FF",
    strokeWidth: 2.66667,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3353 12.5L26.002 11.8333",
    stroke: "#8800FF",
    strokeWidth: 2.66667,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.002 11.8333V23.8333",
    stroke: "#8800FF",
    strokeWidth: 2.66667,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.668 13.1667V26.5",
    stroke: "#8800FF",
    strokeWidth: 2.66667,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddArtistProfile);
export default __webpack_public_path__ + "static/media/add-artist-profile.4470c39d.svg";
export { ForwardRef as ReactComponent };